import logo from './logo.svg';
import './App.css';
import ButtonComponent from './ButtonComponent/ButtonComponent';
import HomeComponent from './HomeComponent/HomeComponent';

function App() {
  return (
    <div className="App">
      <HomeComponent/>
      {/* <ButtonComponent size="lg" onClick={() => alert("Clicked!")}>Primary</ButtonComponent> */}
    </div>
  );
}

export default App;
